// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"design-slider_wrapper__7Gxj0","slider":"design-slider_slider__sBfaM","slide":"design-slider_slide__Rbc_G"};